var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"text-none px-4 rounded-xl",attrs:{"color":"#f5f5f5","large":"","disabled":!_vm.klarnaAppLoaded},on:{"click":_vm.createFlow}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }